
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Aerosole sind in der Regel nur wenige Tausendstel Millimeter (Mikrometer) gross und schweben dadurch über Stunden in der Luft und können sich auch in grossen Räumen rasch verbreiten. Der Arbeitshygieniker und Risikoforscher Michael Riediker hat das Ansteckungsrisiko mit dem neuen Coronavirus Sars-CoV-2 durch Aerosole modelliert und kam vor einem Jahr zum Schluss, dass nur etwa zehn Prozent der Infizierten genügend Viren in sich tragen, um auf diesem Weg das Virus zu übertragen. Mit der Delta-Variante haben nun allerdings viel mehr Personen stark erhöhte Virenlasten. Das bewirkt, dass nun fast jede zweite infizierte Person in gewissen Situationen andere über Aerosole anstecken kann, wie Riediker im `}<a parentName="p" {...{
        "href": "744079947573"
      }}>{`Interview`}</a>{` erläutert.`}</p>
    <p>{`Der Wissenschaftler des Swiss Centre for Occupational and Environmental Health (SCOEH) in Winterthur hat sein Modell im Fachblatt `}<a parentName="p" {...{
        "href": "https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2768712"
      }}>{`«JAMA Network Open»`}</a>{` veröffentlicht und in einem weiteren `}<a parentName="p" {...{
        "href": "https://aaqr.org/articles/aaqr-20-08-covid-0531"
      }}>{`Artikel`}</a>{` einen Ansatz beschrieben, wie sich damit verschiedene Ansteckungssituationen simulieren lassen. Unser Tool basiert auf diesen Daten und wurde nun zusammen mit Riediker auf die hochansteckende Delta-Variante angepasst.`}</p>
    <p><strong parentName="p">{`WICHTIG:`}</strong>{` Das Tool simuliert nur das Ansteckungsrisiko über Aerosole im weiten Feld, also, wenn der Mindestabstand von anderthalb Metern eingehalten wird.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;